import { useHostEnv } from '../hooks';
import dayjs from 'dayjs';
import Tracker from './tracker';
import { getQueryString, consoleLogStyle } from './utils';
import type { Options } from './type';

export const jimoTrackerInit = (opts: Options = {}) => {
  const { currentHostEnv } = useHostEnv();

  // TODO: 从环境变量取真实的前端版本号
  const appVer = dayjs().format('YYYY-MM-DD');

  // projectPath 目前取域名后的一级路径，如 /caizhi_webapp /caizhi-webapp-audit /caizhi-webapp-formal-pi 等
  const firstLevelPath = location.pathname.split('/')?.[1];
  const projectPath = firstLevelPath ? '/' + firstLevelPath : '/caizhi_webapp';
  const enableLog =
    import.meta.env.VITE_ENABLE_JIMO_TRACKER_SDK_LOG === 'on' ||
    sessionStorage.getItem('jimoTrackerLog') === 'on' ||
    getQueryString('_enablelog') === 'on';

  try {
    window._jt_ = window.jimoTracker = new Tracker({
      trackUrl: import.meta.env.VITE_JIMO_TRACKER_SDK_API_URL, // 上报地址
      envName: import.meta.env.MODE || 'test', // 环境名称 dev,test,test2,test3,uat,gray,prod
      nodeEnv: import.meta.env.VITE_USER_NODE_ENV || 'production', // NODE_ENV production, development
      appVer, // 版本号
      projectDesc: opts.projectDesc || projectPath, // 项目描述，目前取取域名后的一级路径
      startSource: currentHostEnv === 'QYWX' ? 2 : 5, // TODO: 多种冷启动类型 未完成
      sdkType: 'h5',
      sdkVer: 'v3.0.0', // v2.0.0 以上 page_desc page_track 分开，新加 page_title project_desc
      gotoSelfPagePaths: ['/articleDetail'],
      enableBodyClick: true, // 开启事件委托
      enableBlockExposure: true, // 开启模块曝光
      enableHideElementExposure: true, // 开启隐藏元素曝光
      enableTouchSlide: true, // 开启触摸滑动事件
      enableLog, // 是否开启日志,
    });
    if (enableLog) {
      console.log('%c[jimo-tracker-sdk]', consoleLogStyle, 'sdk init success');
    }
  } catch {}
};

export const jimoTrackerSetUserData = (params: {
  openId: string;
  unionId: string;
  userId: string;
  mainId: string;
  corpId: string;
  staffId: string;
  userType: string;
  identity: string;
  parameters: {
    is_allow_protocol: number; // 用户是否同意隐私协议授权 0-同意，1-不同意（为了兼容历史数据，字段值对应的含义相反）
    external_user_id: string;
  };
}) => {
  const { openId, unionId, userId, mainId, corpId, staffId, userType, identity, parameters = {} } = params;
  try {
    // jimo-sdk 更新用户数据
    _jt_.setData({
      open_id: openId || (import.meta.env.MODE === 'dev' ? 'om4U66Lr0szB-SsMtR6AqGXcYrP0' : ''), // 本地前端测试机8
      union_id: unionId || '',
      user_id: userId || '',
      main_id: mainId || '',
      corp_id: corpId || '',
      staff_id: staffId,
      user_type: userType, // 用户类型：企业员工、企业客户、潜在客户、游客
      identity: identity || '', // 身份类型 非同事，同事，员工自己
      parameters: {
        ...parameters,
      },
    });
    _jt_.coldStart(); // 执行冷启动
  } catch {}
};
